import { createContext } from 'react';

export type InvoicesCtx = {
  showDownloadErrorAlert: boolean;
};

const InvoicesDialogueContext = createContext<InvoicesCtx>({
  showDownloadErrorAlert: false,
});

export default InvoicesDialogueContext;
